<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='17'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-row>
            <el-button type="primary" size="mini" round plain @click="Createtask()">创建任务</el-button>
            <el-col :span="2" style="float: right;">
              <div style="padding-top:5px;padding-left:45px;" class="thisclose">
                <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
              </div>
            </el-col>
          </el-row>
          <div class="cght_subpagemaina">
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" style="width: 100%" v-loading="isLoading" border>
                  <el-table-column label="任务名称" align="center" width="300">
                    <template slot-scope="scope">
                      <el-popover trigger="hover" placement="top">
                        <p>{{ scope.row.task_name }}</p>
                        <div slot="reference" class="name-wrapper">
                          <span>{{ scope.row.task_name }}</span>
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="提出人" align="center" width="80">
                    <template slot-scope="scope">
                      <div slot="reference" class="name-wrapper">
                        <el-tag size="medium">{{ scope.row.name }}</el-tag>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="提交时间" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{ scope.row.subtime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="跟进人" align="center" width="280">
                    <template slot-scope="scope">
                      <div slot="reference" class="name-wrapper">
                        <template v-for="(item,index) in scope.row.participant_list">
                          <el-tag :key="index" size="medium" :type="item.dstate==1?'danger':'success'" style="margin-left: 5px;margin-top: 5px;">{{ item.name }}</el-tag>
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="300">
                    <template slot-scope="scope">
                      <span style="margin-left: 10px">{{ scope.row.ramke }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                      >
                        <p>确定删除该产品吗？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-for="(item,index) in scopes.row.screenshot" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(item.response)">下载</el-button>
                            <!-- <span style="float: right;cursor: pointer;" @click="dowloadFile(item.response)">下载</span> -->
                          </li>
                        </ul>
                        <el-button v-if="scopes.row.screenshot.length > 0" slot="reference" size="mini" type="text">任务文件</el-button>
                      </el-popover>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-for="(item,index) in scopes.row.participant_list" :key="index" style="padding: 8px 15px 8px;">
                            <span style="font-weight: bold;">{{ item.name }}：</span>
                            <ul>
                              <li v-for="(YF,k) in item.task_file_list" :key="k" style="padding: 8px 15px 8px;">
                                <span>{{ YF.name }}</span>
                                <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(YF.response)">下载</el-button>
                              </li>
                            </ul>
                            <!-- <span style="float: right;cursor: pointer;" @click="dowloadFile(item.response)">下载</span> -->
                          </li>
                        </ul>
                        <el-button slot="reference" size="mini" type="text">进度查看</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="taskMsgList" />
              </el-col>
            </el-row>
            <el-dialog title="任务分配" :visible.sync="dialogFormVisible">
              <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-row>
                  <el-col :span="22">
                    <el-form-item label="任务描述" prop="task_name">
                      <el-input v-model="form.task_name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="提出人">
                      <el-input v-model="current_user.name" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="跟进人" prop="participant">
                      <el-select v-model="form.participant" multiple placeholder="请选择任务跟进人" style="width:313px;">
                        <el-option
                          v-for="item in options"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="任务时间" prop="finish_time">
                      <el-date-picker
                        v-model="form.finish_time"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="22">
                    <el-form-item label="备注" prop="ramke">
                      <el-input v-model="form.ramke" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="上传文件" prop="img">
                      <el-upload
                        ref="upload"
                        class="upload-demo"
                        :action="upload_url"
                        :on-success="handlesuccess"
                        :on-remove="removeUpload"
                        :before-upload="beforeAvatarUpload"
                        accept=".xls,.xlsx,.docx,.doc,.jpg,.pdf,.zip,.rar"
                        :file-list="myfileList"
                        :headers="requestHeaders"
                        :auto-upload="true"
                        :multiple="true"
                        :on-change="onChangeUpload"
                      >
                        <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm()">确 定</el-button>
              </div>
            </el-dialog>
            <el-image
              style="width: 0px; height: 0px"
              :src="url"
              :lazy="true"
              ref="preview"
              :preview-src-list="srcList">
            </el-image>
            <el-image
              style="width: 0px; height: 0px"
              src="https://serv.nmzp.com/uploads/1/image/20240411/80a00fa3ad3f307570961bf8e65621e7.jpg"
              :lazy="true"
              ref="newpreview"
              :preview-src-list="newSrcList"
            >
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import apiConfig from '../../../config/api.config.js'
import api from '@/api/task'
import { getToken, getType } from '@/utils/auth'

export default {
  name: 'TaskDistribution',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'id',
        sort: 'DESC'
      },
      dialogFormVisible: false,
      form: {
        task_name: '',
        participant: '',
        sate: 0,
        introducer: [],
        subtime: '',
        finish_time: '',
        fileList: []
      },
      srcList: [],
      newSrcList: ['https://serv.nmzp.com/uploads/1/image/20240411/80a00fa3ad3f307570961bf8e65621e7.jpg'],
      url: '',
      isLoading: false,
      options: [],
      optionsss: [{
        value: '1',
        label: '待处理'
      }, {
        value: '2',
        label: '处理中'
      }, {
        value: '3',
        label: '已完成'
      }],
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      myfileList: [],
      index: '',
      rules: {
        task_name: [{ required: true, message: '请输入任务描述', trigger: 'blur' }],
        participant: [{ required: true, message: '请选择任务跟进人', trigger: 'blur' }],
        finish_time: [{ required: true, message: '请选择任务完成时间', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
    this.taskMsgList()
    this.getoxen_horses()
  },
  methods: {
    Createtask () {
      this.dialogFormVisible = true
      this.myfileList = []
      this.form = {
        task_name: '',
        participant: '',
        sate: 0,
        introducer: [],
        subtime: '',
        finish_time: '',
        fileList: []
      }
    },
    getoxen_horses () {
      api.getoxen_horses().then(res => {
        this.options = res.data
      })
    },
    taskMsgList () {
      this.isLoading = true
      api.taskMsgList(this.listQuery).then(response => {
        this.list = response.items
        this.total = response.total
        this.isLoading = false
      })
    },
    removeUpload (file, fileList) {
      this.myfileList = fileList
    },
    handlesuccess (response, file, fileList) {
      if (response.code === 20000) {
        // this.myfileList.push({ 'name': file.name, 'url': file.response.message })
        // console.info(fileList)
        // fileList.map((res, index) => {
        //   this.myfileList.push({ 'name': res.name, 'url': res.response.message })
        // })
        this.myfileList = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    onChangeUpload (file, fileList) {
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'zip'
      const extension8 = testmsg === 'rar'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、pdf、zip、rar格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || extension8) && isLt2M
    },
    handleClick (row) {
      const thisType = getType(row.screenshot)
      if (thisType === 'image') {
        this.srcList = [row.screenshot]
        this.url = row.screenshot
        this.$nextTick(() => {
          this.$refs.preview.clickHandler()
        })
      } else if (thisType === 'pdf') {
        window.open(row.screenshot, '_target')
      } else {
        const url = 'http://view.officeapps.live.com/op/view.aspx?src=' + row.screenshot
        window.open(url, '_target')
      }
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.newpreview.clickHandler()
      })
    },
    submitForm () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            return false
          }
          this.locktype = true
          this.form.introducer = this.current_user.id
          this.form.fileList = this.myfileList
          api.submitForm(this.form).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.taskMsgList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.form = Object.assign({}, row)
      this.myfileList = row.screenshot
    },
    dowloadFile (urlFile) {
      window.open(urlFile.message, '_blank')
    },
    handleDelete (row, scopes) {
      api.delete_taskmsg({ id: row.id }).then(res => {
        this.taskMsgList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 55px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/taskDistribution.vue